import Keycloak from "keycloak-js";
import axiosInstance from "./api";

export const keycloakInstance = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: "master",
  clientId: "gamma",
});
let initialization = null;

export function initializeKeycloak() {
  if (!initialization) initialization = keycloakInstance.init({ onLoad: "login-required" });
  return initialization;
}
